import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Footer = () => {
	const [page, setPage] = useState(null);
	const [pageSubviews, setPageSubviews] = useState([]);
	const pageUrl = process.env.REACT_APP_API_PAGE_URL;

	useEffect(() => {
		const fetchData = async () => {
			axios.get(`${pageUrl}e2317867-33e5-4232-a22b-cbc21d5763aa`)
				.then(res => {
					const response = res.data;
					setPage(response);
					/*console.log("Footer", response);*/
				});
		};

		fetchData();
	}, [pageUrl]);


	useEffect(() => {
		if (page != null) {
			setPageSubviews(page.items);
		}
	}, [page]);



	return (
		<>
			<footer className="bg-white pt-5 mt-5">
				<div className="container-lg">
					<div className="row justify-content-between">
						<div className="col-12 mb-4 ps-md-1">
							<Link to='/' className="footer-logo hover-cursor text-black text-uppercase">
								{/*<img src="/Content/img/logo-epoca-black.svg" alt="Logo" className="object-fit-contain h-100 w-100" />*/}
								<strong>EPOCA</strong> | Communication and Marketing Advisoring
							</Link>
						</div>
						<div className="col-12 col-lg-5 col-md-6 border-3 hover-opacity-others border-top d-flex flex-column aling-items-start justify-content-start pt-4 px-2 mb-5 mb-md-0">
							<p className="googleMapsLink text-black text-uppercase" rel="noreferrer">
								MILANO
							</p>
							<p className="googleMapsLink text-black text-uppercase" rel="noreferrer">
								ROMA
							</p>
							<p className="googleMapsLink text-black text-uppercase" rel="noreferrer">
								VICENZA
							</p>
						</div>
						<div className="col-12 col-md-6 border-3 hover-opacity-others border-top d-flex flex-column aling-items-start justify-content-start pt-4 px-2 mb-5 mb-md-0">
							<a className="mail-link text-black text-uppercase" href="mailto:info@epocagroup.it">
								info@epocagroup.it
							</a> 
							<Link to='https://www.linkedin.com/company/epocaadvisoring/' target="_blank" className="hover-cursor text-black text-uppercase d-flex aling-items-center lh-1 d-block mt-2">
								<span className="hover-cursor">Linkedin</span>
								<img src="/Content/img/custom-45-arrow-icon.png" alt="link-icon" className="h-100 link-icon ms-2 object-fit-contain" />
							</Link>
						</div>
						{/*<div className="col-12 col-lg-3 col-md-6 border-3 hover-opacity-others border-top d-flex flex-column aling-items-start justify-content-start pt-4 px-2 mb-5 mb-md-0">*/}
						{/*	<a className="tel-link text-black text-uppercase" href="tel:+390270708899">*/}
						{/*		02 60 70 88 99*/}
						{/*	</a>*/}
						{/*</div>*/}
					</div>
					{/*<div className="row justify-content-end"> */}
					{/*	<div className="col-12 col-lg-3 col-md-6 border-3 hover-opacity-others pt-4 px-2 mb-5 mb-md-0">*/}
					{/*		<Link to='/' target="_blank" className="hover-cursor text-black text-uppercase d-flex aling-items-center lh-1 d-block">*/}
					{/*			<span className="hover-cursor">Linkedin</span>*/}
					{/*			<img src="/Content/img/custom-45-arrow-icon.png" alt="link-icon" className="h-100 link-icon ms-2 object-fit-contain" />*/}
					{/*		</Link>*/}
					{/*	</div> */}
					{/*</div>*/}
				</div>
				<div className="container-fluid mt-5 bg-dark">
					<div className="row mt-4 pt-4 pb-2">
						<div className="col-12 d-flex flex-column flex-md-row aling-items-center justify-content-between">
							<p className="text-white text-start fs-8">&copy; 2024</p>
							<div className="d-flex flex-column flex-md-row aling-items-center justify-content-center hover-opacity-others">
								<Link to='/cookie-policy' className="hover-cursor text-white mx-2 fs-8">
									{pageSubviews.length > 0 && pageSubviews[0].title}
								</Link>
								<Link to='/privacy-policy' className="hover-cursor  text-white mx-2 fs-8">
									{pageSubviews.length > 1 && pageSubviews[1].title}
								</Link>
								<Link to='/note-legali' className="hover-cursor text-white mx-2 fs-8">
									{pageSubviews.length > 2 && pageSubviews[2].title}
								</Link>
							</div>
						</div>
					</div>
					</div>
			</footer>
		</>
	);
};

export default Footer;
